<template>
  <v-row>
    <v-col cols="12" sm="6" offset-sm="3">
        <v-card>
            <v-overlay :value="dLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
            </v-overlay>
            <v-toolbar :color="dColor2" height="220">
                <v-row>
                    <v-col cols="12" xm="10" class="pa-0 d-flex">
                        <v-list two-line :style="{'background-color': dColor2}">
                            <v-list-item style="min-height:5px; padding-left:0px">
                                <v-list-item-icon style="margin:0px 0px 0px 0px"><v-icon style="margin:0px 0px 0px 0px">person</v-icon></v-list-item-icon>
                                <v-list-item-content style="padding: 5px 12px 5px 12px"><v-list-item-title><h5>{{dPriAlumno.Alumno}}</h5></v-list-item-title>
                                    <v-list-item-subtitle>Nombre</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item style="min-height:5px; padding-left:0px">
                                <v-list-item-icon style="margin:0px 0px 0px 0px"><v-icon style="margin:0px 0px 0px 0px">bookmark</v-icon></v-list-item-icon>
                                <v-list-item-content style="padding: 5px 12px 5px 12px"><v-list-item-title><h4>{{dServicio}}</h4></v-list-item-title><v-list-item-subtitle>Carrera</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item style="min-height:5px; padding-left:0px">
                                <v-list-item-icon style="margin:0px 0px 0px 0px"><v-icon style="margin:0px 0px 0px 0px">credit_card</v-icon></v-list-item-icon>
                                <v-list-item-content style="padding: 5px 12px 5px 12px"><v-list-item-title><h4>{{dPriAlumno.DNI}}</h4></v-list-item-title><v-list-item-subtitle>DNI</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                            <v-list-item style="min-height:5px; padding-left:0px">
                                <v-list-item-icon style="margin:0px 0px 0px 0px"><v-icon style="margin:0px 0px 0px 0px">qr_code_2</v-icon></v-list-item-icon>
                                <v-list-item-content style="padding: 5px 12px 5px 12px"><v-list-item-title><h4>{{dPriAlumno.Codigo}}</h4></v-list-item-title><v-list-item-subtitle>Código</v-list-item-subtitle></v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-btn @click="dModal.dialog = true" icon style="top: 8px; position: fixed; right: 0px;" color="primary"><v-icon>search</v-icon></v-btn>
                        <v-avatar size="150" style="border:3px solid; bottom: 10px; position: fixed; right: 5px;" :style="{'border-color': dColor4}">
                            <img v-if="dPriAlumno.Sexo=='F'" src="@/assets/images/userF.svg" alt="Alumno">
                            <img v-else src="@/assets/images/userM.svg" alt="Alumno">
                        </v-avatar>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-list two-line subheader>
                <v-btn v-if="dCotAsistencia.length == 0" @click.prevent="fuSave" block rounded color="primary" dark :loading="dIsUpdating">Registrar Ingreso</v-btn>
                <template v-else>
                    <v-alert v-for="item in dCotAsistencia" :key="item.Id_Asistencia" outlined color="primary" style="margin: 10px; padding: 5px">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>Estudiante ingresó: </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action class='primary--text'>
                                <h2><v-icon color="primary">watch_later</v-icon> {{item.Fecha|fiHora}}</h2>
                            </v-list-item-action>
                        </v-list-item>
                    </v-alert>
                </template>
                <template v-if="dIngPagoPeriodicoMatriculas.length != 0">
                    <v-subheader inset>DEUDAS ENCONTRADAS : <h2 class='red--text'>{{ this.dIngPagoPeriodicoMatriculas.length }}</h2></v-subheader>
                    <v-alert v-for="item in dIngPagoPeriodicoMatriculas" :key="item.IdMes" outlined color="error" style="margin: 10px; padding: 5px">
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>{{ (item.NroCuota-1)|fiCuotaName }}</v-list-item-title>
                                <v-list-item-subtitle>{{ (item.IdMes-1)|fiMonthName }} - {{ (new Date(item.FechaDeuda)).getFullYear() }}</v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action class='red--text'>
                                <h2>s/. {{ item.Deuda }}</h2>
                            </v-list-item-action>
                        </v-list-item>
                    </v-alert>
                </template>
            </v-list>
        </v-card>
    </v-col>
    <v-dialog v-model="dModal.dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="dModal.dialog=false"><v-icon>close</v-icon></v-btn>
                <v-toolbar-title>Buscar Alumno</v-toolbar-title>
            </v-toolbar>
            <v-card-title style="background-color:#78909C">
                <v-form ref="refPriAlumno">
                    <v-row fluid>
                        <v-col cols="9" xm="12" sm="9" md="9" class="pa-1">
                            <v-text-field @keyup.enter="fuPriAlumnoSearch" v-model="dDNINombre" label="DNI o Codigo o Apellidos y Nombres" outlined prepend-inner-icon="credit_card" clearable :rules="[v => !!v || 'El campo es requerido']" :maxlength="120" counter autocomplete="off"></v-text-field>
                        </v-col>
                        <v-col cols="3">
                            <v-btn @click="fuPriAlumnoSearch" :loading="dPriAlumnoTable.loading" color="blue-grey" dark x-large>
                                <v-icon large>search</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-title>
            <v-data-table
                v-model="dPriAlumnoTable.selected"
                :headers="dPriAlumnoTable.headers"
                :items="dPriAlumnos"
                :loading="dPriAlumnoTable.loading"
                single-select
                item-key="IdAlumno"
                class="row-height-50">
                <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
                <template v-slot:[`item.Alumno`]="{ item }">
                    <v-btn @click="fuPriAlumnoSelected(item.IdAlumno)" color="success" text>{{item.Alumno}}</v-btn>
                </template>
                <template v-slot:[`item.priservicio.Iniciales`]="{ item }">
                    <h3 style="color:blue">{{item.priservicio.Iniciales}}</h3>
                </template>
            </v-data-table>
        </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
const arrayMonth = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio','Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
const arrayOrdinaleFemenino = ['Primera', 'Segunda', 'Tercera', 'Cuarta', 'Quinta','Sexta','Septima','Octava']
import moment from 'moment';
import gql from 'graphql-tag';
export default {
    name: 'AlumnoDeuda',
    mounted(){
        if (typeof this.$route.params.pIdAlumno != "undefined"){
            this.fuPriAlumno(this.$route.params.pIdAlumno);
        }
    },
    data: () => ({
        dColor:'success',
        dColor2:'#FFFFFF',
        dColor4:'white',
        dCotAsistencia: [],
        dDNINombre: '',
        dIngPagoPeriodicoMatriculas: [],
        dIsUpdating: false,
        dLoading: false,
        dModal: {
            dialog: false,
            IsUpdating: false,
        },
        dPriAlumnos: [],
        dPriAlumnoTable: {
            headers: [
                {value: 'IdAlumno', text: 'IdAlumno', align: ' d-none'},
                {value: 'Alumno', text: 'Alumno'},                
                {value: 'Codigo', text: 'Codigo'},
                {value: 'priservicio.Iniciales', text: 'Carrera', align: 'center', sortable: false},
                {value: 'DNI', text: 'DNI', align: 'center', sortable: false},
            ],
            loading: false,
            selected: []
        },
        dPriAlumno: {//55443 //debe 53439 54226
            IdAlumno: '',
            DNI: '',
            Alumno: '',
            Sexo: '',
            Codigo: '',
        },
        dServicio: '',
    }),
    computed: {
        cRuta() {
            return this.$route.params.pIdAlumno
        }
    },
    filters: {
        fiMonthName: function (value) {            
            return arrayMonth[value]
        },
        fiCuotaName: function (value) {
            if(value==0)
                return 'Matricula'
            else
                return arrayOrdinaleFemenino[value] + ' cuota';
        },
        fiHora: function (value) {
            return moment(value).format("HH:mm")
        }
    },
    watch: {
        cRuta (val) {
            this.fuPriAlumno(val);
        }
    },
    methods: {
        async fuPriAlumno(pIdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumno($IdAlumno: ID!, $token: String){
                        prialumno(IdAlumno:$IdAlumno, token: $token){
                            IdAlumno
                            DNI
                            Alumno
                            Sexo
                            Codigo
                            priservicio{
                                Iniciales
                            }
                        }
                        ingpagoperiodicomatriculaDeudaAll(IdAlumno:$IdAlumno){
                            IdMatricula
                            FechaDeuda
                            Monto
                            Dsctpp
                            Deuda
                            NroCuota
                            IdMes
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: pIdAlumno,
                        token: new Date().toISOString()
                    }
                })
                this.dPriAlumno.IdAlumno = response.data.prialumno.IdAlumno;
                this.dPriAlumno.DNI = this.dDNI = response.data.prialumno.DNI;
                this.dPriAlumno.Alumno = this.dAlumno = response.data.prialumno.Alumno;
                this.dPriAlumno.Sexo = response.data.prialumno.Sexo;
                this.dPriAlumno.Codigo = response.data.prialumno.Codigo;
                this.dServicio = response.data.prialumno.priservicio.Iniciales;

                var vFechaNow = new Date();
                this.dIngPagoPeriodicoMatriculas = response.data.ingpagoperiodicomatriculaDeudaAll.filter(item => new Date(item.FechaDeuda) < vFechaNow);
                this.fuSave();

                console.log(response.data.prialumno);
                console.log(response.data.ingpagoperiodicomatriculaDeudaAll);

                if(this.dIngPagoPeriodicoMatriculas.length > 0){
                    this.dColor ='error';
                    this.dColor2 ='#FFEBEE';
                    this.dColor4 ='pink';
                } else {
                    this.dColor ='success';
                    this.dColor2 ='#C8E6C9';
                    this.dColor4 ='green';
                }
                
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        },
        fuPriAlumnoSearch(){
            if(this.dDNINombre==''){
                this.dSnackbar = true;
            } else {
                if(this.dDNINombre.length==8 && !isNaN(this.dDNINombre))
                    this.fuPrialumnoByDNI(this.dDNINombre)
                else{
                    if(this.dDNINombre.length==9 && !isNaN(this.dDNINombre.substring(0,5)))
                        this.fuPrialumnoByCodigo(this.dDNINombre)
                    else
                        this.fuPrialumnoByAlumno(this.dDNINombre)
                }
            }
        },
        async fuPrialumnoByCodigo(pCodigo) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByCodigo($Codigo: String!){
                        prialumnoByCodigo(Codigo: $Codigo){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Codigo: pCodigo
                    }
                })
                console.log(response.data.prialumnoByCodigo);
                this.dPriAlumnos = [];
                this.dPriAlumnos.push(response.data.prialumnoByCodigo);
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByDNI(pDni) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByDNI($DNI: String!){
                        prialumnoByDNI(DNI: $DNI){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        DNI: pDni
                    }
                })
                console.log(response.data.prialumnoByDNI);
                this.dPriAlumnos = response.data.prialumnoByDNI;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        async fuPrialumnoByAlumno(pAlumno) {
            this.dPriAlumnoTable.loading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query prialumnoByAlumno($Alumno: String!){
                        prialumnoByAlumno(Alumno: $Alumno){
                            IdAlumno
                            Alumno
                            DNI
                            Codigo
                            Celular
                            Telefono
                            Sexo
                            priservicio{
                                Iniciales
                            }
                        }
                    }`,
                    variables: {
                        Alumno: pAlumno
                    }
                })
                console.log(response.data.prialumnoByAlumno);
                this.dPriAlumnos = response.data.prialumnoByAlumno;
            } catch (error) {
                console.log(error);
            } finally {
                this.dPriAlumnoTable.loading = false
            }
        },
        fuPriAlumnoSelected(vIdAlumno){
            this.fuPriAlumno(vIdAlumno);
            this.dModal.dialog = false;
        },
        async fuSave() {
            try {
                this.dIsUpdating = true;
                this.dCotAsistencia = [];
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation cotasistenciaCreate($input:cotasistenciaCreateInput!){
                        cotasistenciaCreate(
                            input: $input
                        ){
                            Id_Asistencia
                            Fecha
                        }
                    }`,
                    variables: {
                        input: {
                            Id_Persona: this.dPriAlumno.IdAlumno,
                            Fecha: moment().format("YYYYMMDD HH:mm:ss")
                        }
                    }
                });
                if(response.data){
                    console.log(response.data.cotasistenciaCreate);
                    this.dCotAsistencia.push(response.data.cotasistenciaCreate);
                } else {
                    console.log("No se guardo la matricula.");
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó la matricula.', 'error');
            } finally {
                this.dIsUpdating = false;
            }
        },
    }
}
</script>
<style lang="css">
    .v-data-table .v-data-table__mobile-row{
        min-height: 10px;
    }
</style>